"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tldjs = _interopRequireDefault(require("tldjs"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _isValidEmail = _interopRequireDefault(require("./is-valid-email"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var isEmailValid = function isEmailValid(email) {
  if (!_checkTypes["default"].nonEmptyString(email)) {
    return false;
  }

  if (!(0, _isValidEmail["default"])(email)) {
    return false;
  }

  var parts = email.split('@');

  if (parts.length !== 2) {
    return false;
  }

  var domain = parts[1];

  if (!_tldjs["default"].tldExists(domain) || !_tldjs["default"].isValid(domain)) {
    return false;
  }

  return true;
};

var _default = isEmailValid;
exports["default"] = _default;